import { Component, effect, inject, signal } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { CheckForUpdateService } from '@shared/helper/check-for-update.service';
import { appVersion, variables } from '@shared/helper/configs';
import { PromptUpdateService } from '@shared/helper/prompt-update.service';
import { SnackbarService, SnackbarType } from '@shared/helper/snackbar.service';
import { SchemaService } from '@shared/seo/schema.service';
import { GeneralService } from '@shared/services/general.service';
import { TokenService } from '@shared/services/token.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  version = appVersion;
  showContent = signal(false);

  private readonly generalService = inject(GeneralService);
  private readonly matIconRegistry = inject(MatIconRegistry);
  private readonly tokenService = inject(TokenService);
  private readonly router = inject(Router);
  private readonly snackbar = inject(SnackbarService);
  private readonly schemaService = inject(SchemaService);

  constructor(c: CheckForUpdateService, p: PromptUpdateService) {
    effect(() => {
      this.handleInIranAccess();
    });
  }

  ngOnInit(): void {
    this.matIconRegistry.setDefaultFontSetClass('mat-symbol-round');
    this.handleDeviceId();
    this.handleOfflineMode();
    this.getUserSubscriptionDetails();
    this.router.events.subscribe({
      next: (e) => {
        if (e instanceof NavigationEnd) {
          this.schemaService.removeJsonLdScripts();
        }
      },
    });
  }

  private handleDeviceId() {
    if (this.generalService.isBrowserOnly) {
      if (!localStorage.getItem(variables.did)) {
        this.tokenService.getDeviceId().subscribe({
          next: () => {
            this.showContent.set(true);
          },
          error: () => {
            this.showContent.set(true);
          },
        });
      } else {
        this.showContent.set(true);
      }
    } else {
      this.showContent.set(true);
    }
  }

  private handleOfflineMode() {
    if (this.generalService.isBrowserOnly) {
      if (!navigator.onLine) {
        this.generalService.router.navigateByUrl('/error/offline');
      }
    }
  }

  private handleInIranAccess() {
    if (this.generalService.countryCode() !== undefined) {
      if (this.generalService.countryCode() !== 'ir') {
        this.snackbar.showSnackbar(
          'برای تجربه استفاده بهتر از شیدا فیلتر شکن خود را خاموش کنید.',
          SnackbarType.warning,
          'بستن',
        );
      }
    }
  }

  private getUserSubscriptionDetails() {
    if (this.tokenService.getRtk()) {
      this.tokenService.getUserSubscriptionDetails().subscribe({
        next: (res) => {
          if (
            res.data?.remainingDays! > 0 &&
            !this.tokenService.userInfo()?.activeSubscription?.id
          ) {
            this.tokenService.refreshToken().subscribe();
          }
        },
      });
    }
  }
}
